module.exports = __webpack_public_path__ + "static/img/05_ava_training_cornelius_carstens.ad21825.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/ava/05_ava_training_cornelius_carstens.png
// module id = W1X+
// module chunks = 1